import axios from "axios";

const state = {
  operatorFundHistory: [],
  operatorFundBalance: null,
};

const getters = {
  operatorFundHistory(state) {
    return state.operatorFundHistory;
  },

  operatorFundBalance(state) {
    return state.operatorFundBalance;
  },
};

const mutations = {
  setOperatorFundHistory(state, funds) {
    state.operatorFundHistory = funds;
  },

  setOperatorFundBalance(state, balance) {
    state.operatorFundBalance = balance;
  },
};

const actions = {
  async fetchOperatorFundHistory({ commit, rootState }, operator) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/payment/fund-history?operator=${operator}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setOperatorFundHistory", res.data);
      });
  },

  async cancelPaymentOrder({ rootState }, orderId) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.delete(`${apiUrl}/payment/cancel-order/${orderId}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async selcomPaymentCheckout({ rootState }, orderDetail) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/payment/create-order`, orderDetail, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
